module.exports = __webpack_public_path__ + "img/00—03a—Password recovery.f97ae6db.jpg";